/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.gestionbodegas': 'Gestión bodegas',
    'sidebar.bodegas': 'Bodegas',
    'gestionBodega.medida.dimensiones': 'M',
    'gestionBodega.medida.peso': 'Kg',
    'gestionBodega.medida.coordenadas': 'Gr',
    'gestionBodega.agregarBodega': 'Crear bodega',
    'gestionBodega.editarBodega': 'Editar bodega',
    'gestionBodega.datosGenerales': 'Datos generales',
    'gestionBodega.divisionesBodega': 'Divisiones bodega',
    'gestionBodega.personasAsociadas': 'Personas asociadas',
    'gestionBodega.divisionesPorDefecto': 'Configuración documentos división',
    'gestionBodega.MáximosMínimos': 'Máximos y Mínimos',
    'gestionBodega.BodegaCodigo': 'Código bodega',
    'gestionBodega.BodegaDescripcion': 'Descripción bodega',
    'gestionBodega.TipoBodegaDescripcion': 'Tipo bodega',
    'gestionBodega.DescripcionCiudad': 'Ciudad',
    'gestionBodega.Agencias': 'Agencias',
    'gestionBodega.BodegaPadre': 'Bodega padre',
    'gestionBodega.Ancho': 'Ancho',
    'gestionBodega.Alto': 'Alto',
    'gestionBodega.Largo': 'Largo',
    'gestionBodega.Latitud': 'Latitud',
    'gestionBodega.Longitud': 'Longitud',
    'gestionBodega.Estado': 'Estado',
    'gestionBodega.dimensionesInvalidas':
        'Las medidas ingresadas no son válidas, por favor verifique los campos Ancho, Largo, Alto.',
    'gestionBodega.Propiedades.alerta.camposNulos': 'Por favor ingrese todos los campos disponibles',
    'gestionBodega.Propiedades.BodegaTipoPropiedadDescripcion': 'Tipo Propiedad',
    'gestionBodega.Propiedades.DescripcionItem': 'Producto',
    'gestionBodega.Propiedades.FamiliaDescripcion': 'Familia',
    'gestionBodega.Propiedades.BodegaPropiedadTexto': 'Descripción',
    'gestionBodega.Propiedades.DescripcionUnidad': 'Unidad',
    'gestionBodega.Propiedades.Estado': 'Estado',
    'gestionBodega.Propiedades.Cantidad': 'Cantidad',
    'gestionBodega.titulo.datosBodega': 'Datos bodega',
    'gestionBodega.titulo.medidasBodega': 'Medidas bodega',
    'gestionBodega.titulo.propiedadesBodega': 'Propiedades bodega',
    'gestionBodega.titulo.personas': 'Personas',
    'gestionBodega.titulo.divisiones': 'Divisiones',
    'gestionBodega.titulo.divisionesPorDefecto': 'Configuración documentos división',
    'gestionBodega.mensaje.municipiosNoEncontrados': 'No se encontraron ciudades',
    'gestionBodega.propieades.titulo.crearPropiedad': 'Crear propiedad bodega',
    'gestionBodega.propieades.titulo.editarPropiedad': 'Editar propiedad bodega',
    'bodegasPersonas.PersonaId': 'Persona',
    'bodegasPersonas.Estado': 'Estado',
    'bodegasPersonas.BodegaPrincipal': 'Bodega principal',
    'bodegasPersonas.NombrePersona': 'Nombre',
    'bodegasPersonas.agregarBodegasPersonas': 'Asociar persona',
    'bodegasPersonas.modificarBodegasPersonas': 'Editar persona asociada',
    'gestionBodega.Agencia': 'Agencia',
    'divisionBodega.datosDivision': 'Datos división',
    'divisionBodega.medidasDivision': 'Medidas división',
    'divisionBodega.agregarDivisionBodega': 'Crear división',
    'divisionBodega.editarDivisionBodega': 'Editar división',
    'divisionBodega.propiedadesDivision': 'Propiedades división',
    'divisionBodega.TipoDivision': 'Tipo división',
    'divisionBodega.Fila': 'Fila',
    'divisionBodega.Columna': 'Columna',
    'divisionBodega.Piso': 'Piso',
    'divisionBodega.DivisionCodigoBarras': 'Código de barras',
    'divisionBodega.DivisionDescripcion': 'Descripción',
    'divisionBodega.Ancho': 'Ancho',
    'divisionBodega.Largo': 'Largo',
    'divisionBodega.Alto': 'Alto',
    'divisionBodega.Peso': 'Peso',
    'divisionBodega.VolumenDisponible': 'Volumen disponible',
    'divisionBodega.PesoDisponible': 'Peso disponible',
    'divisionBodega.Estado': 'Estado',
    'divisionBodega.Propiedades.agregarPropiedadDivision': 'Crear propiedad división',
    'divisionBodega.Propiedades.editarPropiedadDivision': 'Editar propiedad división',
    'divisionBodega.Propiedades.BodegaTipoPropiedadDescripcion': 'Tipo Propiedad',
    'divisionBodega.Propiedades.DescripcionItem': 'Producto',
    'divisionBodega.Propiedades.FamiliaDescripcion': 'Familia',
    'divisionBodega.Propiedades.BodegaPropiedadTexto': 'Descripción',
    'divisionBodega.Propiedades.DescripcionUnidad': 'Unidad',
    'divisionBodega.Propiedades.Estado': 'Estado',
    'divisionBodega.Propiedades.Cantidad': 'Cantidad',
    'divisionesDocumentosDefecto.TituloDivisionDefecto': 'División Defecto',
    'divisionesDocumentosDefecto.DivisionDescripcion': 'División',
    'divisionesDocumentosDefecto.TipoMovimientoDescripcion': 'Tipo documento',
    'divisionesDocumentosDefecto.agregarDivisionesDocumentosDefecto': 'Configurar documento división',
    'divisionesDocumentosDefecto.modificarDivisionesDocumentosDefecto': 'Editar división por defecto',
    'gestionBodega.Direccion': 'Direccion',
    'gestionBodega.cancelar': 'Los datos no guardados se perderán, ¿Desea cerrar la ventana?',
    'divisionBodega.ColumnaInactiva': ' Registro de columna inactivo, seleccione uno nuevo',
    'divisionBodega.TipoDivisionInactiva': 'Registro de tipo division inactivo, seleccione uno nuevo',
    'divisionBodega.PisoInactivo': 'Registro piso inactivo, seleccione uno nuevo',
    'divisionBodega.FilaInactiva': 'Registro de fila inactivo, seleccione uno nuevo',
    'gestionBodega.BodegaPadreInactiva': 'Registro bodega padre inactivo',
    'gestionBodega.TipoBodegaInactiva': 'Registro tipo bodega inactivo, seleccione uno nuevo',
};
